import { Box } from '@mui/material';
import HeaderSearch from './Search';
import HeaderNotifications from './Notifications';
import FranchiseHomeIcon from './FranchiseHome';
import Walletamount from './WalletAmount';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

function HeaderButtons() {

  const accountType = localStorage.getItem('accountType');
  const operatortypeAccount = localStorage.getItem('operatorData')
  const opeartoraccountconvert = JSON.parse(operatortypeAccount)
  return (
    <Box
      sx={{
        display: 'flex',              // 🔥 IMPORTANT
        alignItems: 'center',
        gap: { xs: 2, sm: 1 },     // 🔥 compact spacing for mobile
        whiteSpace: 'nowrap'         // 🔥 prevent line break
      }}
    >
      {/* Wallet */}
      {accountType !== 'OWNER' && <Walletamount />}

      {/* Home */}
      {accountType === 'DISTRIBUTOR' && <FranchiseHomeIcon />}

      {/* Notifications */}
      <HeaderNotifications />
    </Box>
  );
}

export default HeaderButtons;
